export const gears_rightAngle = [
    {
        ratio: 6.3,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 74, "9025": 98, "9030": 152, "9040": 236, "9050": 334, "9060": 568, "9070": 798, "9080": 1020,
        },
    },
    {
        ratio: 6.3,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 62, "9025": 81, "9030": 127, "9040": 197, "9050": 279, "9060":475, "9070": 667, "9080": 857,
        },
    },
    {
        ratio: 6.3,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 49, "9025": 65, "9030": 102, "9040": 158, "9050": 224, "9060": 381, "9070": 535, "9080": 668,
        },
    },
    {
        ratio: 6.3,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 41, "9025": 54, "9030": 85, "9040": 132, "9050": 187, "9060": 318, "9070": 447, "9080": 575,
        }
    },
    {
        ratio: 7.1,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 62, "9025": 98, "9030": 152, "9040": 228, "9050": 334, "9060": 559, "9070": 798, "9080": 1020,
        },
    },
    {
        ratio: 7.1,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 52, "9025": 81, "9030": 127, "9040": 191, "9050": 279, "9060": 469, "9070": 667, "9080": 857,
        },
    },
    {
        ratio: 7.1,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 42, "9025": 65, "9030": 102, "9040": 153, "9050": 224, "9060": 388, "9070": 535, "9080": 688,
        },
    },
    {
        ratio: 7.1,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 35, "9025": 54, "9030": 85, "9040": 128, "9050": 187, "9060": 316, "9070": 447, "9080": 575,
        },
    },
    {
        ratio: 8,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 57, "9025": 76, "9030": 140, "9035": 152, "9040": 217, "9045": 236, "9050": 340, "9060": 544, "9065": 568, "9070": 810, "9080": 1150,
        },
    },
    {
        ratio: 8,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 47, "9025": 63, "9030": 117, "9035": 127, "9040": 181, "9045": 197, "9050": 285, "9060": 467, "9065": 475, "9070": 705, "9080": 1010,
        },
    },
    {
        ratio: 8,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 38, "9025": 51, "9030": 94, "9035": 102, "9040": 145, "9045": 158, "9050": 229, "9060": 374, "9065": 381, "9070": 568, "9080": 834,
        },
    },
    {
        ratio: 8,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 31, "9025": 42, "9030": 78, "9035": 85, "9040": 120, "9045": 132, "9050": 191, "9060": 312, "9065": 318, "9070": 476, "9080": 699,
        },
    },
    {
        ratio: 9,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 49, "9025": 76, "9030": 126, "9035": 152, "9040": 188, "9045": 236, "9050": 180, "9055": 334, "9060": 443, "9065": 568, "9070": 704, "9075": 798, "9080": 1070, "9095": 1550, "9105": 1880, "9115": 2800,
        },
    },
    {
        ratio: 9,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 41, "9025": 63, "9030": 105, "9035": 127, "9040": 158, "9045": 197, "9050": 234, "9055": 179, "9060": 371, "9065": 475, "9070": 590, "9075": 667, "9080": 897, "9095": 1350, "9105": 1660, "9115": 2460,
        },
    },
    {
        ratio: 9,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 33, "9025": 51, "9030": 85, "9035": 102, "9040": 127, "9045": 158, "9050": 188, "9055": 224, "9060": 298, "9065": 381, "9070": 474, "9075": 535, "9080": 722, "9095": 1120, "9105": 1420, "9115": 2110,
        },
    },
    {
        ratio: 9,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 28, "9025": 42, "9030": 71, "9035": 85, "9040": 106, "9045": 132, "9050": 158, "9055": 187, "9060": 250, "9065": 318, "9070": 397, "9075": 447, "9080": 605, "9095": 964, "9105": 1250, "9115": 1850,
        },
    },
    {
        ratio: 10,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 43, "9025": 72, "9030": 111, "9035": 143, "9040": 161, "9045": 217, "9050": 278, "9055": 351, "9060": 434, "9065": 546, "9070": 677, "9075": 810, "9080": 1000, "9085": 1150, "9095": 1460, "9105": 1880, "9115": 2800,
        },
    },
    {
        ratio: 10,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 36, "9025": 60, "9030": 92, "9035": 119, "9040": 134, "9045": 181, "9050": 232, "9055": 297, "9060": 362, "9065": 469, "9070": 567, "9075": 713, "9080": 863, "9085": 1010, "9095": 1280, "9105": 1660, "9115": 2460,
        },
    },
    {
        ratio: 10,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 29.1, "9025": 48, "9030": 74, "9035": 95, "9040": 107, "9045": 145, "9050": 187, "9055": 237, "9060": 289, "9065": 375, "9070": 456, "9075": 577, "9080": 695, "9085": 867, "9095": 1060, "9105": 1420, "9115": 2060,
        },
    },
    {
        ratio: 10,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 24.3, "9025": 40, "9030": 62, "9035": 79, "9040": 89, "9045": 120, "9050": 156, "9055": 198, "9060": 241, "9065": 313, "9070": 382, "9075": 482, "9080": 582, "9085": 736, "9095": 911, "9105": 1250, "9115": 1770,
        },
    },
    {
        ratio: 11.2,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 39, "9025": 63, "9030": 100, "9035": 133, "9040": 145, "9045": 198, "9050": 229, "9055": 293, "9060": 351, "9065": 462, "9070": 565, "9075": 747, "9080": 892, "9085": 1120, "9095": 1230, "9105": 1570, "9115": 2430,
        },
    },
    {
        ratio: 11.2,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 33, "9025": 52, "9030": 83, "9035": 111, "9040": 121, "9045": 166, "9050": 191, "9055": 245, "9060": 294, "9065": 387, "9070": 473, "9075": 626, "9080": 748, "9085": 938, "9095": 1050, "9105": 1350, "9115": 2140,
        },
    },
    {
        ratio: 11.2,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 26.5, "9025": 42, "9030": 67, "9035": 89, "9040": 97, "9045": 133, "9050": 154, "9055": 197, "9060": 236, "9065": 311, "9070": 381, "9075": 504, "9080": 602, "9085": 756, "9095": 877, "9105": 1180, "9115": 1780,
        },
    },
    {
        ratio: 11.2,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 22.1, "9025": 35, "9030": 56, "9035": 75, "9040": 81, "9045": 111, "9050": 129, "9055": 165, "9060": 198, "9065": 260, "9070": 319, "9075": 421, "9080": 504, "9085": 633, "9095": 752, "9105": 1040, "9115": 1520,
        },
    },
    {
        ratio: 12.5,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 36, "9025": 58, "9030": 89, "9035": 111, "9040": 122, "9045": 161, "9050": 225, "9055": 284, "9060": 322, "9065": 435, "9070": 512, "9075": 700, "9080": 732, "9085": 1000, "9095": 1180, "9105": 1570, "9115": 2310,
        },
    },
    {
        ratio: 12.5,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 30, "9025": 48, "9030": 74, "9035": 93, "9040": 102, "9045": 134, "9050": 188, "9055": 237, "9060": 269, "9065": 362, "9070": 428, "9075": 598, "9080": 612, "9085": 863, "9095": 1010, "9105": 1380, "9115": 1980,
        },
    },
    {
        ratio: 12.5,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 24.2, "9025": 39, "9030": 59, "9035": 74, "9040": 82, "9045": 107, "9050": 150, "9055": 189, "9060": 216, "9065": 290, "9070": 343, "9075": 482, "9080": 491, "9085": 715, "9095": 840, "9105": 1180, "9115": 1640,
        },
    },
    {
        ratio: 12.5,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 20.1, "9025": 32, "9030": 49, "9035": 62, "9040": 68, "9045": 89, "9050": 125, "9055": 158, "9060": 180, "9065": 242, "9070": 284, "9075": 403, "9080": 410, "9085": 600, "9095": 721, "9105": 1040, "9115": 1410,
        },
    },
    {
        ratio: 14,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 32, "9025": 51, "9030": 82, "9035": 105, "9040": 116, "9045": 152, "9050": 188, "9055": 239, "9060": 283, "9065": 366, "9070": 450, "9075": 600, "9080": 688, "9085": 933, "9095": 993, "9105": 1280, "9115": 1980,
        },
    },
    {
        ratio: 14,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 27.3, "9025": 43, "9030": 69, "9035": 88, "9040": 97, "9045": 126, "9050": 158, "9055": 200, "9060": 237, "9065": 306, "9070": 377, "9075": 502, "9080": 576, "9085": 782, "9095": 852, "9105": 1130, "9115": 1700,
        },
    },
    {
        ratio: 14,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 21.9, "9025": 34, "9030": 55, "9035": 71, "9040": 78, "9045": 101, "9050": 127, "9055": 161, "9060": 190, "9065": 246, "9070": 303, "9075": 404, "9080": 463, "9085": 629, "9095": 706, "9105": 966, "9115": 1410,
        },
    },
    {
        ratio: 14,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 18.3, "9025": 28.7, "9030": 46, "9035": 59, "9040": 65, "9045": 84, "9050": 106, "9055": 134, "9060": 159, "9065": 206, "9070": 253, "9075": 338, "9080": 388, "9085": 527, "9095": 605, "9105": 850, "9115": 1210,
        },
    },
    {
        ratio: 16,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 27.1, "9025": 42, "9030": 67, "9035": 89, "9040": 96, "9045": 122, "9050": 169, "9055": 226, "9060": 261, "9065": 322, "9070": 373, "9075": 512, "9080": 545, "9085": 732, "9095": 953, "9105": 1280, "9115": 1840,
        },
    },
    {
        ratio: 16,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 22.6, "9025": 35, "9030": 56, "9035": 74, "9040": 80, "9045": 102, "9050": 141, "9055": 188, "9060": 218, "9065": 269, "9070": 311, "9075": 428, "9080": 455, "9085": 612, "9095": 817, "9105": 1330, "9115": 1580,
        },
    },
    {
        ratio: 16,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 18.1, "9025": 28.5, "9030": 45, "9035": 59, "9040": 64, "9045": 82, "9050": 113, "9055": 150, "9060": 175, "9065": 216, "9070": 250, "9075": 343, "9080": 365, "9085": 491, "9095": 678, "9105": 966, "9115": 1310,
        },
    },
    {
        ratio: 16,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 15.1, "9025": 23.7, "9030": 37, "9035": 49, "9040": 54, "9045": 68, "9050": 94, "9055": 125, "9060": 146, "9065": 180, "9070": 208, "9075": 286, "9080": 305, "9085": 410, "9095": 581, "9105": 850, "9115": 1120,
        },
    },
    {
        ratio: 18,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 23.5, "9025": 37, "9030": 64, "9035": 86, "9040": 95, "9045": 117, "9050": 145, "9055": 197, "9060": 230, "9065": 295, "9070": 368, "9075": 478, "9080": 545, "9085": 719, "9095": 803, "9105": 1040, "9115": 1590,
        },
    },
    {
        ratio: 18,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 21.1, "9025": 31, "9030": 53, "9035": 72, "9040": 79, "9045": 98, "9050": 122, "9055": 165, "9060": 193, "9065": 247, "9070": 308, "9075": 400, "9080": 455, "9085": 602, "9095": 689, "9105": 918, "9115": 1370,
        },
    },
    {
        ratio: 18,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 17, "9025": 25.1, "9030": 43, "9035": 57, "9040": 63, "9045": 78, "9050": 98, "9055": 132, "9060": 155, "9065": 198, "9070": 247, "9075": 321, "9080": 365, "9085": 484, "9095": 571, "9105": 785, "9115": 1130,
        },
    },
    {
        ratio: 18,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 14.2, "9025": 20.9, "9030": 36, "9035": 48, "9040": 53, "9045": 65, "9050": 81, "9055": 111, "9060": 129, "9065": 166, "9070": 207, "9075": 269, "9080": 305, "9085": 405, "9095": 490, "9105": 691, "9115": 975,
        },
    },
    {
        ratio: 20,
        poles: 4,
        frequency: 60,
        models: {
            "9030": 61, "9040": 81, "9050": 124, "9060": 194, "9070": 295, "9080": 516, "9090": 735, "9100": 992, "9110": 1520,
        },
    },
    {
        ratio: 20,
        poles: 4,
        frequency: 50,
        models: {
            "9030": 51, "9040": 67, "9050": 103, "9060": 162, "9070": 246, "9080": 431, "9090": 616, "9100": 829, "9110": 1270,
        },
    },
    {
        ratio: 20,
        poles: 6,
        frequency: 60,
        models: {
            "9030": 41, "9040": 54, "9050": 83, "9060": 130, "9070": 198, "9080": 346, "9090": 495, "9100": 666, "9110": 1020,
        },
    },
    {
        ratio: 20,
        poles: 6,
        frequency: 50,
        models: {
            "9030": 34, "9040": 45, "9050": 69, "9060": 108, "9070": 165, "9080": 298, "9090": 413, "9100": 556, "9110": 856,
        },
    },
    {
        ratio: 22.4,
        poles: 4,
        frequency: 60,
        models: {
            "9030": 55, "9040": 81, "9050": 124, "9060": 194, "9070": 295, "9080": 476, "9090": 696, "9095": 735, "9105": 992, "9110": 1360, "9115": 1520,
        },
    },
    {
        ratio: 22.4,
        poles: 4,
        frequency: 50,
        models: {
            "9030": 46, "9040": 67, "9050": 103, "9060": 162, "9070": 246, "9080": 398, "9090": 582, "9095": 616, "9105": 829, "9110": 1160, "9115": 1270,
        },
    },
    {
        ratio: 22.4,
        poles: 6,
        frequency: 60,
        models: {
            "9030": 37, "9040": 54, "9050": 93, "9060": 130, "9070": 198, "9080": 320, "9090": 468, "9095": 495, "9105": 666, "9110": 936, "9115": 1020,
        },
    },
    {
        ratio: 22.4,
        poles: 6,
        frequency: 50,
        models: {
            "9030": 31, "9040": 45, "9050": 69, "9060": 108, "9070": 165, "9080": 268, "9090": 391, "9095": 413, "9105": 556, "9110": 783, "9115": 856,
        },
    },
    {
        ratio: 25,
        poles: 4,
        frequency: 60,
        models: {
            "9030": 49, "9035": 64, "9040": 80, "9050": 117, "9055": 124, "9060": 193, "9070": 295, "9080": 453, "9085": 516, "9090": 625, "9095": 714, "9100": 912, "9105": 992, "9110": 1270, "9115": 1360, "9118": 1520,
        },
    },
    {
        ratio: 25,
        poles: 4,
        frequency: 50,
        models: {
            "9030": 41, "9035": 54, "9040": 67, "9050": 98, "9055": 103, "9060": 162, "9070": 246, "9080": 379, "9085": 431, "9090": 528, "9095": 613, "9100": 763, "9105": 829, "9110": 1090, "9115": 1170, "9118": 1270,
        },
    },
    {
        ratio: 25,
        poles: 6,
        frequency: 60,
        models: {
            "9030": 33, "9035": 43, "9040": 53, "9050": 78, "9055": 83, "9060": 130, "9070": 198, "9080": 304, "9085": 346, "9090": 424, "9095": 495, "9100": 613, "9105": 666, "9110": 910, "9115": 970, "9118": 1020,
        },
    },
    {
        ratio: 25,
        poles: 6,
        frequency: 50,
        models: {
            "9030": 27.8, "9035": 36, "9040": 45, "9050": 65, "9055": 69, "9060": 108, "9070": 165, "9080": 254, "9085": 289, "9090": 355, "9095": 413, "9100": 513, "9105": 556, "9110": 771, "9115": 827, "9118": 856,
        },
    },
    {
        ratio: 28,
        poles: 4,
        frequency: 60,
        models: {
            "9030": 44, "9035": 58, "9040": 65, "9045": 81, "9050": 96, "9055": 124, "9060": 152, "9065": 194, "9070": 251, "9075": 295, "9080": 392, "9085": 498, "9090": 559, "9095": 625, "9100": 812, "9105": 970, "9110": 1130, "9115": 1280, "9121": 1930, "9126": 2060, "9131": 3110, "9136": 3260,
        },
    },
    {
        ratio: 28,
        poles: 4,
        frequency: 50,
        models: {
            "9030": 37, "9035": 49, "9040": 55, "9045": 67, "9050": 80, "9055": 103, "9060": 127, "9065": 162, "9070": 210, "9075": 146, "9080": 328, "9085": 417, "9090": 468, "9095": 536, "9100": 679, "9105": 825, "9110": 949, "9115": 1090, "9121": 1610, "9126": 1770, "9131": 2600, "9136": 2800,
        },
    },
    {
        ratio: 28,
        poles: 6,
        frequency: 60,
        models: {
            "9030": 29.9, "9035": 39, "9040": 44, "9045": 54, "9050": 64, "9055": 83, "9060": 102, "9065": 130, "9070": 168, "9075": 198, "9080": 263, "9085": 335, "9090": 376, "9095": 444, "9100": 546, "9105": 663, "9110": 763, "9115": 910, "9121": 1300, "9126": 1460, "9131": 2090, "9136": 2320,
        },
    },
    {
        ratio: 28,
        poles: 6,
        frequency: 50,
        models: {
            "9030": 25, "9035": 33, "9040": 36, "9045": 45, "9050": 54, "9055": 69, "9060": 85, "9065": 108, "9070": 141, "9075": 165, "9080": 220, "9085": 280, "9090": 314, "9095": 379, "9100": 456, "9105": 554, "9110": 638, "9115": 781, "9121": 1080, "9126": 1250, "9131": 1750, "9136": 1990,
        },
    },
    {
        ratio: 31.5,
        poles: 4,
        frequency: 60,
        models: {
            "9030": 32, "9035": 51, "9040": 57, "9045": 81, "9050": 92, "9055": 124, "9060": 140, "9065": 194, "9070": 225, "9075": 295, "9080": 331, "9085": 473, "9090": 508, "9095": 589, "9100": 708, "9105": 877, "9110": 988, "9115": 1140, "9118": 1380, "9121": 1780, "9126": 1920, "9131": 2730, "9136": 2910,
        },
    },
    {
        ratio: 31.5,
        poles: 4,
        frequency: 50,
        models: {
            "9030": 26.9, "9035": 43, "9040": 48, "9045": 67, "9050": 79, "9055": 103, "9060": 117, "9065": 162, "9070": 190, "9075": 246, "9080": 280, "9085": 399, "9090": 425, "9095": 498, "9100": 592, "9105": 734, "9110": 823, "9115": 978, "9118": 1150, "9121": 1490, "9126": 1640, "9131": 2280, "9136": 2500,
        },
    },
    {
        ratio: 31.5,
        poles: 6,
        frequency: 60,
        models: {
            "9030": 21.5, "9035": 34, "9040": 38, "9045": 54, "9050": 64, "9055": 83, "9060": 94, "9065": 130, "9070": 152, "9075": 198, "9080": 224, "9085": 321, "9090": 341, "9095": 400, "9100": 476, "9105": 590, "9110": 658, "9115": 806, "9118": 923, "9121": 1200, "9126": 1360, "9131": 1840, "9136": 2070,
        },
    },
    {
        ratio: 31.5,
        poles: 6,
        frequency: 50,
        models: {
            "9030": 18, "9035": 29.1, "9040": 32, "9045": 45, "9050": 53, "9055": 69, "9060": 78, "9065": 108, "9070": 127, "9075": 165, "9080": 187, "9085": 268, "9090": 285, "9095": 335, "9100": 398, "9105": 493, "9110": 548, "9115": 674, "9118": 769, "9121": 1000, "9126": 1160, "9131": 1530, "9136": 1770,
        },
    },
    {
        ratio: 35.5,
        poles: 4,
        frequency: 60,
        models: {
            "9030": 32, "9035": 47, "9040": 51, "9045": 69, "9050": 78, "9055": 100, "9060": 127, "9065": 159, "9070": 202, "9075": 266, "9080": 301, "9085": 410, "9090": 450, "9095": 522, "9100": 630, "9105": 766, "9110": 878, "9115": 988, "9118": 1330, "9121": 1530, "9126": 1690, "9128": 2110, "9131": 2480, "9136": 2680,
        },
    },
    {
        ratio: 35.5,
        poles: 4,
        frequency: 50,
        models: {
            "9030": 26.9, "9035": 39, "9040": 42, "9045": 57, "9050": 65, "9055": 84, "9060": 106, "9065": 133, "9070": 169, "9075": 223, "9080": 251, "9085": 343, "9090": 376, "9095": 448, "9100": 527, "9105": 640, "9110": 734, "9115": 823, "9118": 1110, "9121": 1280, "9126": 1450, "9128": 1760, "9131": 2070, "9136": 2300,
        },
    },
    {
        ratio: 35.5,
        poles: 6,
        frequency: 60,
        models: {
            "9030": 21.5, "9035": 31, "9040": 34, "9045": 46, "9050": 52, "9055": 67, "9060": 85, "9065": 106, "9070": 135, "9075": 179, "9080": 202, "9085": 276, "9090": 302, "9095": 364, "9100": 424, "9105": 514, "9110": 590, "9115": 658, "9118": 895, "9121": 1030, "9126": 1200, "9128": 1420, "9131": 1670, "9136": 1910,
        },
    },
    {
        ratio: 35.5,
        poles: 6,
        frequency: 50,
        models: {
            "9030": 18, "9035": 26.4, "9040": 29, "9045": 38, "9050": 44, "9055": 56, "9060": 71, "9065": 89, "9070": 113, "9075": 149, "9080": 169, "9085": 230, "9090": 253, "9095": 304, "9100": 354, "9105": 430, "9110": 193, "9115": 548, "9118": 748, "9121": 866, "9126": 1000, "9128": 1180, "9131": 1390, "9136": 1630,
        },
    },
    {
        ratio: 40,
        poles: 4,
        frequency: 60,
        models: {
            "9030": 30, "9035": 32, "9040": 50, "9045": 57, "9050": 73, "9055": 92, "9060": 124, "9065": 140, "9070": 194, "9075": 225, "9080": 286, "9085": 331, "9090": 408, "9095": 479, "9100": 577, "9105": 682, "9110": 641, "9115": 917, "9118": 1240, "9121": 1420, "9126": 1570, "9128": 1940, "9131": 2170, "9136": 2390,
        },
    },
    {
        ratio: 40,
        poles: 4,
        frequency: 50,
        models: {
            "9030": 25.8, "9035": 26.9, "9040": 41, "9045": 48, "9050": 61, "9055": 49, "9060": 103, "9065": 117, "9070": 162, "9075": 190, "9080": 239, "9085": 280, "9090": 341, "9095": 401, "9100": 483, "9105": 570, "9110": 723, "9115": 775, "9118": 1030, "9121": 1180, "9126": 1350, "9128": 1630, "9131": 1820, "9136": 2050,
        },
    },
    {
        ratio: 40,
        poles: 6,
        frequency: 60,
        models: {
            "9030": 20.7, "9035": 21.5, "9040": 33, "9045": 38, "9050": 49, "9055": 65, "9060": 83, "9065": 94, "9070": 130, "9075": 152, "9080": 192, "9085": 224, "9090": 274, "9095": 322, "9100": 388, "9105": 458, "9110": 581, "9115": 623, "9118": 835, "9121": 955, "9126": 1110, "9128": 1310, "9131": 1460, "9136": 1700,
        },
    },
    {
        ratio: 40,
        poles: 6,
        frequency: 50,
        models: {
            "9030": 17.3, "9035": 18, "9040": 28, "9045": 32, "9050": 40, "9055": 56, "9060": 69, "9065": 78, "9070": 109, "9075": 127, "9080": 160, "9085": 187, "9090": 229, "9095": 269, "9100": 324, "9105": 383, "9110": 486, "9115": 521, "9118": 698, "9121": 799, "9126": 930, "9128": 1090, "9131": 1220, "9136": 1440,
        },
    },
    {
        ratio: 45,
        poles: 4,
        frequency: 60,
        models: {
            "9030": 27.8, "9035": 32, "9040": 41, "9045": 53, "9050": 60, "9055": 82, "9060": 97, "9065": 133, "9070": 162, "9075": 214, "9080": 248, "9085": 315, "9090": 362, "9095": 430, "9100": 54, "9105": 624, "9110": 715, "9115": 861, "9118": 1050, "9121": 1220, "9126": 1390, "9128": 1670, "9131": 197, "9136": 2200,
        },
    },
    {
        ratio: 45,
        poles: 4,
        frequency: 50,
        models: {
            "9030": 23.1, "9035": 26.9, "9040": 34, "9045": 44, "9050": 50, "9055": 68, "9060": 81, "9065": 111, "9070": 135, "9075": 179, "9080": 207, "9085": 263, "9090": 302, "9095": 364, "9100": 429, "9105": 522, "9110": 598, "9115": 739, "9118": 882, "9121": 1020, "9126": 1190, "9128": 1400, "9131": 1650, "9136": 1890,
        },
    },
    {
        ratio: 45,
        poles: 6,
        frequency: 60,
        models: {
            "9030": 18.6, "9035": 21.5, "9040": 28, "9045": 35, "9050": 40, "9055": 55, "9060": 65, "9065": 89, "9070": 108, "9075": 144, "9080": 166, "9085": 211, "9090": 243, "9095": 292, "9100": 345, "9105": 419, "9110": 480, "9115": 610, "9118": 709, "9121": 822, "9126": 957, "9128": 1120, "9131": 1330, "9136": 1560,
        },
    },
    {
        ratio: 45,
        poles: 5,
        frequency: 50,
        models: {
            "9030": 15.6, "9035": 18, "9040": 23, "9045": 30, "9050": 33, "9055": 16, "9060": 54, "9065": 74, "9070": 91, "9075": 120, "9080": 139, "9085": 176, "9090": 203, "9095": 244, "9100": 288, "9105": 350, "9110": 402, "9115": 508, "9118": 593, "9121": 687, "9126": 800, "9128": 943, "9131": 1110, "9136": 1310,
        },
    },
    {
        ratio: 50,
        poles: 4,
        frequency: 60,
        models: {
            "9030": 19.3, "9035": 32, "9045": 51, "9050": 59, "9055": 78, "9060": 97, "9065": 130, "9070": 153, "9075": 199, "9080": 231, "9085": 295, "9090": 322, "9095": 385, "9100": 459, "9105": 555, "9110": 691, "9115": 755, "9118": 988, "9121": 1120, "9126": 1290, "9128": 1540, "9131": 1730, "9136": 1970,
        },
    },
    {
        ratio: 50,
        poles: 4,
        frequency: 50,
        models: {
            "9030": 16.1, "9035": 26.9, "9045": 42, "9050": 49, "9055": 65, "9060": 81, "9065": 110, "9070": 128, "9075": 170, "9080": 193, "9085": 252, "9090": 269, "9095": 322, "9100": 384, "9105": 464, "9110": 578, "9115": 632, "9118": 827, "9121": 945, "9126": 1090, "9128": 1290, "9131": 1450, "9136": 1690,
        },
    },
    {
        ratio: 50,
        poles: 6,
        frequency: 60,
        models: {
            "9030": 12.9, "9035": 21.5, "9045": 35, "9050": 39, "9055": 52, "9060": 65, "9065": 88, "9070": 102, "9075": 137, "9080": 155, "9085": 202, "9090": 216, "9095": 258, "9100": 308, "9105": 373, "9110": 464, "9115": 507, "9118": 664, "9121": 759, "9126": 883, "9128": 1040, "9131": 1160, "9136": 1370,
        },
    },
    {
        ratio: 50,
        poles: 6,
        frequency: 50,
        models: {
            "9030": 10.8, "9035": 18, "9045": 28.6, "9050": 33, "9055": 43, "9060": 54, "9065": 73, "9070": 86, "9075": 115, "9080": 129, "9085": 169, "9090": 180, "9095": 216, "9100": 257, "9105": 312, "9110": 388, "9115": 424, "9118": 555, "9121": 634, "9126": 738, "9128": 870, "9131": 974, "9136": 1140,
        },
    },
];



export const gears_parallel = [
    {
        ratio: 6.3,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 76, "9025": 122, "9030": 179, "9040": 257, "9050": 350, "9060": 603, "9070": 900, "9080": 1430, "9090": 1950, "9100": 2970, "9110": 3900,
        },
    },
    {
        ratio: 6.3,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 64, "9025": 102, "9030": 149, "9040": 223, "9050": 305, "9060": 530, "9070": 792, "9080": 1250, "9090": 1710, "9100": 2610, "9110": 3440,
        },
    },
    {
        ratio: 6.3,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 51, "9025": 82, "9030": 120, "9040": 187, "9050": 256, "9060": 448, "9070": 677, "9080": 1050, "9090": 1450, "9100": 2160, "9110": 2940,
        },
    },
    {
        ratio: 6.3,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 43, "9025": 68, "9030": 100, "9040": 162, "9050": 222, "9060": 388, "9070": 588, "9080": 1884, "9090": 1240, "9100": 1810, "9110": 2550,
        },
    },
    {
        ratio: 7.1,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 62, "9025": 93, "9030": 161, "9040": 241, "9050": 349, "9060": 559, "9070": 900, "9080": 1350, "9090": 1830, "9095": 1950, "9100": 2790, "9105": 2970, "9110": 3460, "9115": 3910,
        },
    },
    {
        ratio: 7.1,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 52, "9025": 83, "9030": 135, "9040": 201, "9050": 293, "9060": 469, "9070": 757, "9080": 1130, "9090": 1610, "9095": 1710, "9100": 2380, "9105": 2610, "9110": 3050, "9115": 3440,
        },
    },
    {
        ratio: 7.1,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 42, "9025": 67, "9030": 108, "9040": 162, "9050": 235, "9060": 377, "9070": 610, "9080": 914, "9090": 1320, "9095": 1450, "9100": 1920, "9105": 2230, "9110": 2600, "9115": 2940,
        },
    },
    {
        ratio: 7.1,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 35, "9025": 56, "9030": 90, "9040": 136, "9050": 197, "9060": 316, "9070": 511, "9080": 766, "9090": 1100, "9095": 1240, "9100": 1610, "9105": 1900, "9110": 2240, "9115": 2550,
        },
    },
    {
        ratio: 8,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 61, "9025": 99, "9030": 140, "9035": 187, "9040": 219, "9045": 257, "9050": 311, "9055": 350, "9060": 517, "9065": 603, "9070": 781, "9075": 900, "9080": 1230, "9085": 1430, "9090": 1660, "9095": 1830, "9100": 2480, "9105": 2790, "9110": 3200, "9115": 3460,
        },
    },
    {
        ratio: 8,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 51, "9025": 83, "9030": 117, "9035": 156, "9040": 190, "9045": 223, "9050": 271, "9055": 305, "9060": 455, "9065": 530, "9070": 687, "9075": 792, "9080": 1030, "9085": 1250, "9090": 1450, "9095": 1610, "9100": 2120, "9105": 2450, "9110": 2820, "9115": 3050,
        },
    },
    {
        ratio: 8,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 41, "9025": 67, "9030": 94, "9035": 126, "9040": 154, "9045": 184, "9050": 227, "9055": 256, "9060": 378, "9065": 448, "9070": 571, "9075": 677, "9080": 836, "9085": 1070, "9090": 1200, "9095": 1360, "9100": 1710, "9105": 2080, "9110": 2350, "9115": 2610,
        },
    },
    {
        ratio: 8,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 34, "9025": 56, "9030": 78, "9035": 105, "9040": 129, "9045": 162, "9050": 195, "9055": 222, "9060": 317, "9065": 388, "9070": 478, "9075": 588, "9080": 700, "9085": 932, "9090": 1020, "9095": 1170, "9100": 1430, "9105": 1740, "9110": 2020, "9115": 2260,
        },
    },
    {
        ratio: 9,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 49, "9025": 81, "9030": 126, "9035": 170, "9040": 188, "9045": 253, "9050": 286, "9055": 350, "9060": 443, "9065": 583, "9070": 708, "9075": 900, "9080": 1070, "9085": 1410, "9090": 1560, "9095": 1660, "9100": 2250, "9105": 2480, "9110": 2840, "9115": 3200,
        },
    },
    {
        ratio: 9,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 41, "9025": 68, "9030": 105, "9035": 142, "9040": 158, "9045": 212, "9050": 239, "9055": 305, "9060": 371, "9065": 489, "9070": 593, "9075": 792, "9080": 900, "9085": 1180, "9090": 1340, "9095": 1450, "9100": 1890, "9105": 2190, "9110": 2500, "9115": 2820,
        },
    },
    {
        ratio: 9,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 33, "9025": 55, "9030": 85, "9035": 114, "9040": 127, "9045": 170, "9050": 192, "9055": 246, "9060": 298, "9065": 393, "9070": 477, "9075": 647, "9080": 725, "9085": 956, "9090": 1080, "9095": 1200, "9100": 1520, "9105": 1820, "9110": 2070, "9115": 2350,
        },
    },
    {
        ratio: 9,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 28, "9025": 46, "9030": 71, "9035": 96, "9040": 106, "9045": 142, "9050": 161, "9055": 206, "9060": 250, "9065": 329, "9070": 400, "9075": 542, "9080": 607, "9085": 801, "9090": 907, "9095": 1030, "9100": 1270, "9105": 1550, "9110": 1740, "9115": 2020,
        },
    },
    {
        ratio: 10,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 47, "9025": 78, "9030": 115, "9035": 146, "9040": 188, "9045": 219, "9050": 259, "9055": 311, "9060": 452, "9065": 517, "9070": 689, "9075": 781, "9080": 1020, "9085": 1230, "9090": 1380, "9095": 1560, "9100": 2090, "9105": 2330, "9110": 2780, "9115": 2850,
        },
    },
    {
        ratio: 10,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 40, "9025": 65, "9030": 96, "9035": 122, "9040": 158, "9045": 190, "9050": 226, "9055": 271, "9060": 382, "9065": 455, "9070": 593, "9075": 687, "9080": 861, "9085": 1080, "9090": 1180, "9095": 1370, "9100": 1760, "9105": 2040, "9110": 2400, "9115": 2500,
        },
    },
    {
        ratio: 10,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 32, "9025": 52, "9030": 77, "9035": 98, "9040": 127, "9045": 159, "9050": 184, "9055": 227, "9060": 307, "9065": 384, "9070": 477, "9075": 588, "9080": 693, "9085": 881, "9090": 964, "9095": 1130, "9100": 1410, "9105": 1640, "9110": 1990, "9115": 2090,
        },
    },
    {
        ratio: 10,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 26.9, "9025": 44, "9030": 64, "9035": 82, "9040": 106, "9045": 136, "9050": 154, "9055": 197, "9060": 257, "9065": 333, "9070": 399, "9075": 505, "9080": 580, "9085": 738, "9090": 807, "9095": 966, "9100": 1180, "9105": 1380, "9110": 1700, "9115": 1790,
        },
    },
    {
        ratio: 11.2,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 39, "9025": 64, "9030": 103, "9035": 133, "9040": 154, "9045": 198, "9050": 225, "9055": 299, "9060": 360, "9065": 462, "9070": 592, "9075": 751, "9080": 891, "9085": 1120, "9090": 1260, "9095": 1380, "9100": 1860, "9105": 2150, "9110": 2470, "9115": 2780
        }
    },
    {
        ratio: 11.2,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 32, "9025": 53, "9030": 86, "9035": 111, "9040": 129, "9045": 166, "9050": 188, "9055": 250, "9060": 301, "9065": 387, "9070": 495, "9075": 629, "9080": 746, "9085": 941, "9090": 1060, "9095": 1180, "9100": 1560, "9105": 1850, "9110": 2130, "9115": 2400
        }
    },
    {
        ratio: 11.2,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 26.2, "9025": 43, "9030": 69, "9035": 89, "9040": 104, "9045": 133, "9050": 151, "9055": 201, "9060": 242, "9065": 311, "9070": 399, "9075": 507, "9080": 600, "9085": 758, "9090": 855, "9095": 981, "9100": 1260, "9105": 1530, "9110": 1720, "9115": 1990
        }
    },
    {
        ratio: 11.2,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 21.9, "9025": 36, "9030": 58, "9035": 75, "9040": 87, "9045": 111, "9050": 127, "9055": 168, "9060": 202, "9065": 260, "9070": 334, "9075": 424, "9080": 503, "9085": 635, "9090": 716, "9095": 842, "9100": 1050, "9105": 1280, "9110": 1440, "9115": 1340
        }
    },

    {
        ratio: 12.5,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 38, "9025": 61, "9030": 89, "9035": 120, "9040": 145, "9045": 191, "9050": 222, "9055": 259, "9060": 366, "9065": 452, "9070": 547, "9075": 689, "9080": 804, "9085": 1060, "9090": 1110, "9095": 1290, "9100": 1630, "9105": 2020, "9110": 2240, "9115": 2470
        },
    },
    {
        ratio: 12.5,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 32, "9025": 51, "9030": 75, "9035": 100, "9040": 121, "9045": 165, "9050": 185, "9055": 226, "9060": 307, "9065": 398, "9070": 458, "9075": 607, "9080": 673, "9085": 908, "9090": 959, "9095": 1110, "9100": 1360, "9105": 1690, "9110": 1920, "9115": 2130
        },
    },
    {
        ratio: 12.5,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 25.8, "9025": 41, "9030": 60, "9035": 80, "9040": 97, "9045": 133, "9050": 149, "9055": 190, "9060": 246, "9065": 328, "9070": 368, "9075": 504, "9080": 542, "9085": 731, "9090": 773, "9095": 910, "9100": 1100, "9105": 1360, "9110": 1590, "9115": 1770
        },
    },
    {
        ratio: 12.5,
        poles: 5,
        frequency: 50,
        models: {
            "9015": 21.5, "9025": 34, "9030": 50, "9035": 67, "9040": 81, "9045": 111, "9050": 125, "9055": 164, "9060": 206, "9065": 274, "9070": 308, "9075": 422, "9080": 453, "9085": 612, "9090": 647, "9095": 762, "9100": 922, "9105": 1140, "9110": 1360, "9115": 1520
        },
    },
    {
        ratio: 14,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 31, "9025": 50, "9030": 81, "9035": 109, "9040": 118, "9045": 162, "9050": 183, "9055": 235, "9060": 589, "9065": 375, "9070": 457, "9075": 628, "9080": 696, "9085": 931, "9090": 1010, "9095": 1110, "9100": 1450, "9105": 1700, "9110": 1990, "9115": 2240
        },
    },
    {
        ratio: 14,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 26.1, "9025": 42, "9030": 67, "9035": 91, "9040": 99, "9045": 136, "9050": 153, "9055": 197, "9060": 242, "9065": 314, "9070": 383, "9075": 526, "9080": 583, "9085": 780, "9090": 851, "9095": 958, "9100": 1210, "9105": 1460, "9110": 1690, "9115": 1920
        },
    },
    {
        ratio: 14,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 21, "9025": 34, "9030": 54, "9035": 73, "9040": 79, "9045": 109, "9050": 123, "9055": 158, "9060": 194, "9065": 252, "9070": 308, "9075": 423, "9080": 469, "9085": 628, "9090": 685, "9095": 794, "9100": 980, "9105": 1190, "9110": 1360, "9115": 1590
        },
    },
    {
        ratio: 14,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 17.5, "9025": 28.5, "9030": 45, "9035": 61, "9040": 66, "9045": 91, "9050": 102, "9055": 132, "9060": 162, "9065": 211, "9070": 257, "9075": 354, "9080": 392, "9085": 526, "9090": 573, "9095": 681, "9100": 821, "9105": 996, "9110": 1140, "9115": 1370
        },
    },
    {
        ratio: 16,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 31, "9025": 50, "9030": 72, "9035": 94, "9040": 116, "9045": 152, "9050": 170, "9055": 237, "9060": 281, "9065": 389, "9070": 440, "9075": 565, "9080": 663, "9085": 846, "9090": 920, "9095": 1050, "9100": 1330, "9105": 1570, "9110": 1870, "9115": 2000
        },
    },
    {
        ratio: 16,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 25.9, "9025": 42, "9030": 60, "9035": 78, "9040": 94, "9045": 127, "9050": 142, "9055": 198, "9060": 235, "9065": 327, "9070": 368, "9075": 484, "9080": 555, "9085": 709, "9090": 773, "9095": 902, "9100": 1110, "9105": 1310, "9110": 1600, "9115": 1710
        },
    },
    {
        ratio: 16,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 20.8, "9025": 33, "9030": 48, "9035": 63, "9040": 78, "9045": 102, "9050": 114, "9055": 159, "9060": 189, "9065": 263, "9070": 296, "9075": 389, "9080": 446, "9085": 571, "9090": 622, "9095": 730, "9100": 898, "9105": 1060, "9110": 1330, "9115": 1420
        },
    },
    {
        ratio: 16,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 17.4, "9025": 28.2, "9030": 40, "9035": 52, "9040": 65, "9045": 85, "9050": 95, "9055": 133, "9060": 158, "9065": 220, "9070": 248, "9075": 325, "9080": 373, "9085": 478, "9090": 520, "9095": 611, "9100": 752, "9105": 887, "9110": 1120, "9115": 1200
        },
    },
    {
        ratio: 18,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 25.3, "9025": 41, "9030": 65, "9035": 85, "9040": 95, "9045": 124, "9050": 140, "9055": 191, "9060": 222, "9065": 301, "9070": 368, "9075": 485, "9080": 574, "9085": 728, "9090": 818, "9095": 920, "9100": 1180, "9105": 1420, "9110": 1650, "9115": 1870
        },
    },
    {
        ratio: 18,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 21.1, "9025": 34, "9030": 54, "9035": 71, "9040": 80, "9045": 104, "9050": 117, "9055": 159, "9060": 185, "9065": 252, "9070": 308, "9075": 406, "9080": 481, "9085": 610, "9090": 685, "9095": 789, "9100": 994, "9105": 1200, "9110": 1380, "9115": 1610
        },
    },
    {
        ratio: 18,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 17, "9025": 27.6, "9030": 43, "9035": 57, "9040": 64, "9045": 84, "9050": 94, "9055": 128, "9060": 149, "9065": 203, "9070": 247, "9075": 326, "9080": 386, "9085": 490, "9090": 551, "9095": 654, "9100": 799, "9105": 971, "9110": 1110, "9115": 1330
        },
    },
    {
        ratio: 18,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 14.2, "9025": 23.1, "9030": 36, "9035": 48, "9040": 53, "9045": 70, "9050": 78, "9055": 107, "9060": 124, "9065": 169, "9070": 207, "9075": 273, "9080": 323, "9085": 410, "9090": 461, "9095": 555, "9100": 669, "9105": 812, "9110": 931, "9115": 1140
        },
    },
    {
        ratio: 20,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 26.4, "9025": 39, "9030": 61, "9040": 98, "9050": 154, "9060": 254, "9070": 356, "9080": 554, "9090": 758, "9100": 1100, "9110": 1500,
        },
    },
    {
        ratio: 20,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 22.1, "9025": 33, "9030": 51, "9040": 82, "9050": 129, "9060": 213, "9070": 310, "9080": 463, "9090": 650, "9100": 922, "9110": 1290,
        },
    },
    {
        ratio: 20,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 17.7, "9025": 27.8, "9030": 41, "9040": 66, "9050": 103, "9060": 171, "9070": 250, "9080": 372, "9090": 527, "9100": 742, "9110": 1070,
        },
    },
    {
        ratio: 20,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 14.8, "9025": 23.6, "9030": 34, "9040": 55, "9050": 86, "9060": 143, "9070": 209, "9080": 311, "9090": 441, "9100": 620, "9110": 919,
        },
    },
    {
        ratio: 22.4,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 21.5, "9025": 34, "9030": 55, "9040": 80, "9050": 127, "9060": 201, "9070": 310, "9080": 480, "9090": 694, "9095": 758, "9100": 981, "9105": 1140, "9110": 1340, "9115": 1500,
        },
    },
    {
        ratio: 22.4,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 18, "9025": 28.8, "9030": 46, "9040": 67, "9050": 106, "9060": 168, "9070": 260, "9080": 401, "9090": 581, "9095": 650, "9100": 821, "9105": 982, "9110": 1140, "9115": 1290, "9131": 3290, "9136": 3430,
        },
    },
    {
        ratio: 22.4,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 14.4, "9025": 23.1, "9030": 37, "9040": 54, "9050": 85, "9060": 135, "9070": 208, "9080": 322, "9090": 467, "9095": 539, "9100": 660, "9105": 801, "9110": 919, "9115": 1070, "9131": 2650, "9136": 2840,
        },
    },
    {
        ratio: 22.4,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 12.1, "9025": 19.3, "9030": 30, "9040": 45, "9050": 71, "9060": 112, "9070": 174, "9080": 269, "9090": 391, "9095": 462, "9100": 552, "9105": 670, "9110": 769, "9115": 919, "9131": 2220, "9136": 2440,
        },
    },
    {
        ratio: 25,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 21.4, "9025": 32, "9030": 49, "9035": 64, "9040": 79, "9045": 100, "9050": 118, "9055": 165, "9060": 195, "9065": 261, "9070": 299, "9075": 356, "9080": 456, "9085": 572, "9090": 624, "9095": 713, "9100": 898, "9105": 1060, "9110": 1250, "9115": 1340, "9118": 1590,
        },
    },
    {
        ratio: 25,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 17.8, "9025": 28.2, "9030": 41, "9035": 53, "9040": 66, "9045": 83, "9050": 98, "9055": 138, "9060": 163, "9065": 226, "9070": 250, "9075": 310, "9080": 382, "9085": 488, "9090": 527, "9095": 612, "9100": 752, "9105": 888, "9110": 1080, "9115": 1150, "9118": 1400, "9131": 2890, "9136": 3060,
        },
    },
    {
        ratio: 25,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 14.3, "9025": 22.9, "9030": 32, "9035": 43, "9040": 53, "9045": 67, "9050": 79, "9055": 110, "9060": 131, "9065": 182, "9070": 201, "9075": 260, "9080": 307, "9085": 392, "9090": 423, "9095": 497, "9100": 604, "9105": 714, "9110": 895, "9115": 954, "9118": 1190, "9131": 2320, "9136": 2530,
        },
    },
    {
        ratio: 25,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 12, "9025": 19.1, "9030": 27.5, "9035": 35, "9040": 44, "9045": 55, "9050": 66, "9055": 92, "9060": 109, "9065": 152, "9070": 168, "9075": 220, "9080": 256, "9085": 328, "9090": 354, "9095": 416, "9100": 505, "9105": 597, "9110": 757, "9115": 812, "9118": 1050, "9131": 1940, "9136": 2170,
        },
    },
    {
        ratio: 28,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 17.4, "9025": 28, "9030": 44, "9035": 58, "9040": 65, "9045": 84, "9050": 97, "9055": 132, "9060": 154, "9065": 209, "9070": 249, "9075": 329, "9080": 395, "9085": 502, "9090": 558, "9095": 624, "9100": 800, "9105": 957, "9110": 1110, "9115": 1260, "9121": 1870, "9126": 2000, "9128": 2640,
        },
    },
    {
        ratio: 28,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 14.5, "9025": 23.4, "9030": 37, "9035": 48, "9040": 54, "9045": 70, "9050": 81, "9055": 111, "9060": 129, "9065": 175, "9070": 208, "9075": 275, "9080": 330, "9085": 420, "9090": 467, "9095": 535, "9100": 669, "9105": 813, "9110": 932, "9115": 1080, "9121": 1570, "9126": 1720, "9128": 2230, "9131": 2550, "9136": 2750,
        },
    },
    {
        ratio: 28,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 11.7, "9025": 18.8, "9030": 29.7, "9035": 39, "9040": 43, "9045": 56, "9050": 65, "9055": 89, "9060": 103, "9065": 140, "9070": 167, "9075": 221, "9080": 265, "9085": 337, "9090": 375, "9095": 444, "9100": 538, "9105": 653, "9110": 749, "9115": 896, "9121": 1260, "9126": 1430, "9128": 1790, "9131": 2050, "9136": 2280,
        },
    },
    {
        ratio: 28,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 9.7, "9025": 15.7, "9030": 24.8, "9035": 32, "9040": 36, "9045": 47, "9050": 54, "9055": 74, "9060": 86, "9065": 117, "9070": 140, "9075": 185, "9080": 222, "9085": 282, "9090": 314, "9095": 378, "9100": 450, "9105": 546, "9110": 626, "9115": 768, "9121": 1050, "9126": 1220, "9128": 1500, "9131": 1720, "9136": 1960,
        },
    },
    {
        ratio: 31.5,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 16.9, "9025": 26.1, "9030": 38, "9035": 51, "9040": 63, "9045": 81, "9050": 98, "9055": 126, "9060": 163, "9065": 208, "9070": 239, "9075": 315, "9080": 355, "9085": 481, "9090": 511, "9095": 588, "9100": 722, "9105": 865, "9110": 1040, "9115": 1120, "9118": 1530, "9121": 1730, "9126": 1870, "9128": 2460,
        },
    },
    {
        ratio: 31.5,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 14.1, "9025": 21.8, "9030": 31, "9035": 42, "9040": 52, "9045": 68, "9050": 82, "9055": 105, "9060": 136, "9065": 174, "9070": 200, "9075": 264, "9080": 297, "9085": 402, "9090": 427, "9095": 497, "9100": 604, "9105": 724, "9110": 898, "9115": 963, "9118": 1280, "9121": 1450, "9126": 1600, "9128": 2060, "9131": 2240, "9136": 2450,
        },
    },
    {
        ratio: 31.5,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 11.3, "9025": 17.4, "9030": 25.5, "9035": 34, "9040": 42, "9045": 54, "9050": 66, "9055": 84, "9060": 109, "9065": 140, "9070": 160, "9075": 212, "9080": 238, "9085": 323, "9090": 343, "9095": 400, "9100": 485, "9105": 581, "9110": 727, "9115": 791, "9118": 1030, "9121": 1160, "9126": 1330, "9128": 1660, "9131": 1800, "9136": 2030,
        },
    },
    {
        ratio: 31.5,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 9.4, "9025": 14.5, "9030": 21.3, "9035": 28.8, "9040": 35, "9045": 45, "9050": 55, "9055": 71, "9060": 91, "9065": 117, "9070": 134, "9075": 177, "9080": 199, "9085": 270, "9090": 287, "9095": 334, "9100": 406, "9105": 486, "9110": 608, "9115": 661, "9118": 865, "9121": 977, "9126": 1130, "9128": 1380, "9131": 1500, "9136": 1740,
        },
    },
    {
        ratio: 35.5,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 13.7, "9025": 21.4, "9030": 34, "9035": 46, "9040": 51, "9045": 68, "9050": 81, "9055": 101, "9060": 128, "9065": 160, "9070": 199, "9075": 265, "9080": 307, "9085": 413, "9090": 453, "9095": 525, "9100": 643, "9105": 781, "9110": 895, "9115": 1040, "9118": 1300, "9121": 1530, "9126": 1690, "9128": 2110,
        },
    },
    {
        ratio: 35.5,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 11.5, "9025": 17.9, "9030": 28.6, "9035": 39, "9040": 43, "9045": 57, "9050": 68, "9055": 85, "9060": 107, "9065": 134, "9070": 167, "9075": 221, "9080": 257, "9085": 346, "9090": 379, "9095": 450, "9100": 538, "9105": 653, "9110": 749, "9115": 899, "9118": 1090, "9121": 1280, "9126": 1450, "9128": 1760, "9131": 2110, "9136": 2340,
        },
    },
    {
        ratio: 35.5,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 9.2, "9025": 14.4, "9030": 23, "9035": 31, "9040": 34, "9045": 45, "9050": 54, "9055": 68, "9060": 86, "9065": 107, "9070": 134, "9075": 178, "9080": 206, "9085": 278, "9090": 304, "9095": 366, "9100": 432, "9105": 525, "9110": 602, "9115": 745, "9118": 878, "9121": 1030, "9126": 1200, "9128": 1420, "9131": 1700, "9136": 1940,
        },
    },
    {
        ratio: 35.5,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 7.7, "9025": 12, "9030": 19.2, "9035": 26.2, "9040": 29, "9045": 38, "9050": 45, "9055": 57, "9060": 72, "9065": 90, "9070": 112, "9075": 148, "9080": 172, "9085": 232, "9090": 254, "9095": 306, "9100": 361, "9105": 439, "9110": 503, "9115": 639, "9118": 735, "9121": 866, "9126": 1000, "9128": 1180, "9131": 1420, "9136": 1660,
        },
    },
    {
        ratio: 40,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 13.6, "9025": 21.2, "9030": 30, "9035": 39, "9040": 50, "9045": 64, "9050": 75, "9055": 105, "9060": 125, "9065": 174, "9070": 192, "9075": 252, "9080": 292, "9085": 374, "9090": 411, "9095": 482, "9100": 589, "9105": 695, "9110": 875, "9115": 933, "9118": 1190, "9121": 1420, "9126": 1570, "9128": 1940,
        },
    },
    {
        ratio: 40,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 11.4, "9025": 17.7, "9030": 25.5, "9035": 33, "9040": 42, "9045": 53, "9050": 63, "9055": 88, "9060": 104, "9065": 145, "9070": 160, "9075": 211, "9080": 244, "9085": 313, "9090": 343, "9095": 403, "9100": 492, "9105": 581, "9110": 738, "9115": 791, "9118": 1030, "9121": 1180, "9126": 1350, "9128": 1630, "9131": 1850, "9136": 2080,
        },
    },
    {
        ratio: 40,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 9.1, "9025": 14.2, "9030": 20.4, "9035": 26.7, "9040": 34, "9045": 42, "9050": 50, "9055": 70, "9060": 84, "9065": 116, "9070": 129, "9075": 169, "9080": 196, "9085": 251, "9090": 276, "9095": 324, "9100": 395, "9105": 467, "9110": 593, "9115": 635, "9118": 831, "9121": 955, "9126": 1110, "9128": 1310, "9131": 1490, "9136": 1730,
        },
    },
    {
        ratio: 40,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 7.6, "9025": 11.9, "9030": 17.1, "9035": 22.3, "9040": 28.5, "9045": 35, "9050": 42, "9055": 59, "9060": 70, "9065": 96, "9070": 107, "9075": 141, "9080": 164, "9085": 210, "9090": 230, "9095": 271, "9100": 330, "9105": 390, "9110": 495, "9115": 531, "9118": 695, "9121": 799, "9126": 930, "9128": 1090, "9131": 1240, "9136": 1470,
        },
    },
    {
        ratio: 45,
        poles: 4,
        frequency: 60,
        models: {
            "9015": 11.1, "9025": 17.4, "9030": 27.5, "9035": 36, "9040": 41, "9045": 54, "9050": 62, "9055": 85, "9060": 98, "9065": 134, "9070": 160, "9075": 212, "9080": 253, "9085": 321, "9090": 364, "9095": 432, "9100": 524, "9105": 636, "9110": 730, "9115": 876, "9118": 1030, "9121": 1210, "9126": 1380, "9128": 1740,
        },
    },
    {
        ratio: 45,
        poles: 4,
        frequency: 50,
        models: {
            "9015": 9.3, "9025": 14.5, "9030": 22.9, "9035": 30, "9040": 34, "9045": 45, "9050": 52, "9055": 71, "9060": 82, "9065": 112, "9070": 134, "9075": 177, "9080": 211, "9085": 269, "9090": 304, "9095": 366, "9100": 438, "9105": 532, "9110": 610, "9115": 751, "9118": 865, "9121": 1010, "9126": 1180, "9128": 1460, "9131": 1670, "9136": 1910,
        },
    },
    {
        ratio: 45,
        poles: 6,
        frequency: 60,
        models: {
            "9015": 7.4, "9025": 11.6, "9030": 18.4, "9035": 24.3, "9040": 27.9, "9045": 36, "9050": 41, "9055": 57, "9060": 66, "9065": 90, "9070": 107, "9075": 142, "9080": 170, "9085": 216, "9090": 244, "9095": 294, "9100": 352, "9105": 427, "9110": 490, "9115": 623, "9118": 695, "9121": 816, "9126": 949, "9128": 1170, "9131": 1340, "9136": 1580,
        },
    },
    {
        ratio: 45,
        poles: 6,
        frequency: 50,
        models: {
            "9015": 6.2, "9025": 9.7, "9030": 15.4, "9035": 20.3, "9040": 23.3, "9045": 30, "9050": 34, "9055": 47, "9060": 55, "9065": 75, "9070": 89, "9075": 118, "9080": 142, "9085": 180, "9090": 204, "9095": 246, "9100": 294, "9105": 357, "9110": 410, "9115": 524, "9118": 581, "9121": 682, "9126": 794, "9128": 981, "9131": 1120, "9136": 1320
        },
    },
    {
        ratio: 50,
        poles: 4,
        frequency: 60,
        models: {
            "9030": 24.6, "9035": 31, "9040": 40, "9045": 51, "9050": 61, "9055": 81, "9060": 100, "9065": 133, "9070": 148, "9075": 203, "9080": 218, "9085": 308, "9090": 316, "9095": 388, "9100": 464, "9105": 566, "9110": 695, "9115": 770, "9118": 1000, "9121": 1120, "9126": 1280, "9128": 1610,
        },
    },
    {
        ratio: 50,
        poles: 4,
        frequency: 50,
        models: {
            "9030": 20.5, "9035": 26.7, "9040": 33, "9045": 43, "9050": 51, "9055": 67, "9060": 84, "9065": 111, "9070": 124, "9075": 169, "9080": 182, "9085": 257, "9090": 264, "9095": 324, "9100": 388, "9105": 484, "9110": 581, "9115": 644, "9118": 843, "9121": 937, "9126": 1090, "9128": 1340, "9131": 1460, "9136": 1700,
        },
    },
    {
        ratio: 50,
        poles: 6,
        frequency: 60,
        models: {
            "9030": 16.5, "9035": 21.4, "9040": 27, "9045": 34, "9050": 41, "9055": 54, "9060": 67, "9065": 89, "9070": 99, "9075": 136, "9080": 146, "9085": 207, "9090": 212, "9095": 260, "9100": 311, "9105": 380, "9110": 467, "9115": 517, "9118": 677, "9121": 753, "9126": 876, "9128": 1080, "9131": 1170, "9136": 1390,
        },
    },
    {
        ratio: 50,
        poles: 6,
        frequency: 50,
        models: {
            "9030": 13.8, "9035": 17.9, "9040": 22.5, "9045": 28.9, "9050": 34, "9055": 45, "9060": 56, "9065": 74, "9070": 83, "9075": 113, "9080": 122, "9085": 173, "9090": 177, "9095": 217, "9100": 160, "9105": 318, "9110": 390, "9115": 432, "9118": 566, "9121": 629, "9126": 732, "9128": 906, "9131": 986, "9136": 1160,
        },
    },

];

export const gearWeight_rightAngle = {
    "9015": 95,
    "9025": 140,
    "9030": 210,
    "9035": 230,
    "9040": 325,
    "9045": 395,
    "9050": 460,
    "9055": 520,
    "9060": 670,
    "9065": 825,
    "9070": 960,
    "9075": 1180,
    "9080": 1390,
    "9085": 1650,
    "9090": 2150,
    "9095": 2400,
    "9100": 2880,
    "9105": 3440,
    "9110": 4160,
    "9115": 4610,
    "9118": 5100,
    "9121": 6150,
    "9126": 6450,
    "9128": 7400,
    "9131": 9850,
    "9136": 10200,
};

export const gearWeight_parallel = {
    "9015": 95,
    "9025": 140,
    "9030": 210,
    "9035": 230,
    "9040": 325,
    "9045": 395,
    "9050": 460,
    "9055": 520,
    "9060": 670,
    "9065": 825,
    "9070": 960,
    "9075": 1180,
    "9080": 1390,
    "9085": 1650,
    "9090": 2150,
    "9095": 2400,
    "9100": 2880,
    "9105": 3440,
    "9110": 4160,
    "9115": 4610,
    "9118": 5100,
    "9121": 6150,
    "9126": 6450,
    "9128": 7400,
    "9131": 9850,
    "9136": 10200,
};
